<template>
  <div v-if="montana_aviso_legal">
    <vs-checkbox
      :value="reserva_nodo.montana_aviso_legal_checked"
      @input="montana_aviso_legal_checked(index)"
      :disabled="reserva_nodo.cantidad > 0 ? true : false"
      style="margin-top: 10px; display: inline-block"
    ></vs-checkbox>
    <span style="vertical-align: super">
      He leído y acepto y de conformidad con lo previsto por el nuevo Reglamento
      de Protección de Datos Personales 2016/679 se le informa de que los datos
      obtenidos voluntariamente a través de este formulario son responsabilidad
      de Federación Aragonesa de Montañismo (FAM), que los obtendrá con la
      finalidad de la gestión de federados y de tramitación de la
      correspondiente licencia y del seguro que de ella se derivan, así como el
      envío de la licencia federativa. Sus datos serán cedidos a FEDME y a la
      entidad encargada de la celebración del seguro. Puede ampliar más
      información a través de este enlace a
      <a target="_blank" href="https://www.fam.es/aviso-legal">Aviso Legal</a> y
      <a target="_blank" href="https://www.fam.es/politica-de-privacidad"
        >Política de privacidad</a
      >.
    </span>
  </div>
</template>

<script>
export default {
  name: "MontanaAvisoLegal",
  props: {
    montana_aviso_legal: Number,
    reserva_nodo: Object,
    index: Number,
  },
  data() {
    return {};
  },
  methods: {
    montana_aviso_legal_checked(index) {
      this.$store.commit("montana_aviso_legal_checked", {
        index: index,
      });
    },
  },
};
</script>
